// extracted by mini-css-extract-plugin
export default {"ProviderContainer":"Provider_ProviderContainer__iCkYi","ProviderEmpty":"Provider_ProviderEmpty__5sPI-"};